import { render, staticRenderFns } from "./Info5gTile.vue?vue&type=template&id=3e158744"
import script from "./Info5gTile.vue?vue&type=script&lang=js"
export * from "./Info5gTile.vue?vue&type=script&lang=js"
import style0 from "./Info5gTile.vue?vue&type=style&index=0&id=3e158744&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports